/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateModelDto
 */
export interface UpdateModelDto {
    /**
     * モデル名
     * @type {string}
     * @memberof UpdateModelDto
     */
    name: string;
    /**
     * 説明
     * @type {string}
     * @memberof UpdateModelDto
     */
    description?: string;
    /**
     * ワークフロー定義
     * @type {object}
     * @memberof UpdateModelDto
     */
    definition: object;
    /**
     * データスキーマ
     * @type {object}
     * @memberof UpdateModelDto
     */
    dataSchema: object;
    /**
     * データアクセスポリシー
     * @type {object}
     * @memberof UpdateModelDto
     */
    policy: object;
}

/**
 * Check if a given object implements the UpdateModelDto interface.
 */
export function instanceOfUpdateModelDto(value: object): value is UpdateModelDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('definition' in value) || value['definition'] === undefined) return false;
    if (!('dataSchema' in value) || value['dataSchema'] === undefined) return false;
    if (!('policy' in value) || value['policy'] === undefined) return false;
    return true;
}

export function UpdateModelDtoFromJSON(json: any): UpdateModelDto {
    return UpdateModelDtoFromJSONTyped(json, false);
}

export function UpdateModelDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateModelDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'definition': json['definition'],
        'dataSchema': json['dataSchema'],
        'policy': json['policy'],
    };
}

export function UpdateModelDtoToJSON(json: any): UpdateModelDto {
    return UpdateModelDtoToJSONTyped(json, false);
}

export function UpdateModelDtoToJSONTyped(value?: UpdateModelDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'definition': value['definition'],
        'dataSchema': value['dataSchema'],
        'policy': value['policy'],
    };
}

